import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import deviceFetch from "../utils/deviceFetch";

const TOKEN_KEY = "turnstileDeviceToken";
const DEVICE_ID_KEY = "turnstileDeviceId";

export default function TurnstileLogin() {
  const nav = useNavigate();
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || "");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const goIfTokenValid = async (t) => {
    setLoading(true);
    setErr("");
    try {
      const res = await deviceFetch("/api/turnstile/device/me", {
        cache: "no-store",
        deviceToken: t,
      });
      const data = await res.json();
      const id = data?.device?.id;
      if (!id) throw new Error("NO_DEVICE_ID");

      localStorage.setItem(TOKEN_KEY, t);
      localStorage.setItem(`turnstileDeviceToken:${id}`, t);
      localStorage.setItem(DEVICE_ID_KEY, String(id));
      nav(`/turnstile/${id}`);
    } catch (e) {
      setErr("Неверный токен устройства или устройство выключено");
    } finally {
      setLoading(false);
    }
  };

  // если токен уже есть — сразу пробуем зайти
  useEffect(() => {
    const t = (token || "").trim();
    if (t) goIfTokenValid(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container" style={{ padding: 24, maxWidth: 520 }}>
      <h1 style={{ marginBottom: 12 }}>Вход в турникет</h1>

      <input
        value={token}
        onChange={(e) => setToken(e.target.value)}
        placeholder="Введите API-token устройства"
        style={{ width: "100%", padding: 10, marginBottom: 12 }}
      />

      {err && <div style={{ marginBottom: 12 }}>{err}</div>}

      <button
        onClick={() => goIfTokenValid((token || "").trim())}
        disabled={loading}
        style={{ width: "100%", padding: 10 }}
      >
        {loading ? "Проверяем..." : "Войти"}
      </button>
    </div>
  );
}